import {
  REMOVE_FOLLOWED_GROUP,
  RESET_LEADERS_PAGE,
  SET_FOLLOWED_GROUPS,
  SET_ALL_GROUPS_FOR_FOLLOWED_LEADERS,
  SET_FOLLOWED_POSTS,
  SET_FOLLOW_FILTER,
  SET_FOLLOW_LIST,
  SET_LEADERS_LIST,
  SET_LEADER_GROUPS,
  SET_LEADER_SEARCH_TERM,
  UPDATE_FOLLOW_LIST,
} from '../../constants';
import { IReduxAction } from '../../interfaces';
import { ILeadersListConfig } from '../reducers';
import {
  addNewGroupMember,
  getFollowing,
  getGroupById,
  getLeaderGroups,
  getLeaders,
  removeFollowing,
  removeGroupMember,
  startFollowing,
  updateFollowing,
  userCanAccess,
} from '../../../services';
import { getPostsByGroupId } from '../../../services/posts';
import { getGroupsByLeaderId } from '../../../services/groups/service';
import { getDataForLeaders } from '../../../services/user_profiles/service';

export const getLeadersList = async (currUser: any, config: ILeadersListConfig, dispatch: any) => {
  const leaderList: any = await getLeaders(currUser, config);
  dispatch(setLeadersList(leaderList));
};

export const getLeaderGroupsList = async (ownerId: any, dispatch: any) => {
  const following: any = await getLeaderGroups(ownerId);
  dispatch(setLeaderGroups(following));
};

export const getMyLeaders = async (userId: any, dispatch: any) => {
  const followingResponse = await getFollowing(userId);
  const responseWithLeaderData = await getDataForLeaders(followingResponse);
  dispatch(setFollowList(responseWithLeaderData.following));
};

export const followLeaderGroup =
  async (following: boolean, member: any, groupId: string, data: any, dispatch: any) => {
    const followThisGroup = following ? startFollowing : updateFollowing;
    Promise.all([
      addNewGroupMember(groupId, member),
      followThisGroup(member.uid, data),
    ])
      .then((response) => {
        dispatch(updateFollowList(data));
      })
        .then(() => loadFollowedLeaderGroups(data.leader.id, dispatch))
      .catch((error) => {
        throw error;
      });
  };

export const unFollowLeaderGroup =
  async (member: any, groupId: string, data: any, dispatch: any) => {
    Promise.all([
      removeGroupMember(groupId, member),
      removeFollowing(member.uid, data),
    ])
      .then((response) => {
        dispatch(removeFollowList(data));
      })
      .catch((error) => {
        throw error;
      });
  };

export const userCanAccessPosts =
  async (groupId: any, user: any) => await userCanAccess(groupId, user);

export const loadGroupPosts =
  async (leaderId: string, groupId: string, user: any, dispatch: any): Promise<void> => {
    const config = {
      search: '',
      filter: 'all',
      tags: 'all',
      sort: 'date-descend',
      pagination: {
        limit: 25,
        lastItem: null,
      },
    };

    const allowedAccess: boolean = await userCanAccess(groupId, user);

    const posts: any = allowedAccess
      ? await getPostsByGroupId(leaderId, groupId, config)
      : { posts: [] };

    dispatch({
      payload: {
        leaderId,
        groupId,
        posts: posts.posts,
      },
      type: SET_FOLLOWED_POSTS,
    });
  };

export const loadFollowedGroups =
  async (groupIds: string[], leaderId: string, dispatch: any): Promise<void> => {
    const groups = await Promise.all(
      groupIds.map(async (group: any) => await getGroupById(group.id)),
    )
      .catch((error) => {
        throw error;
      });
    dispatch(setFollowedGroups({ leaderId, groups }));
  };

export const loadFollowedLeaderGroups =
  async (leaderId: string, dispatch: any): Promise<void> => {
    const allGroups = await getGroupsByLeaderId(leaderId);
    dispatch(setAllGroupsForFollowedLeaders({ leaderId, allGroups }));
  };

export const setFollowFilter = (payload: any): IReduxAction => ({
  payload,
  type: SET_FOLLOW_FILTER,
});

export const setLeadersList = (payload: any): IReduxAction => ({
  payload,
  type: SET_LEADERS_LIST,
});

export const setLeaderSearchTerm = (payload: any): IReduxAction => ({
  payload,
  type: SET_LEADER_SEARCH_TERM,
});

export const setLeaderGroups = (payload: any): IReduxAction => ({
  payload,
  type: SET_LEADER_GROUPS,
});

export const setFollowList = (payload: any): IReduxAction => ({
  payload,
  type: SET_FOLLOW_LIST,
});

export const setFollowedGroups = (payload: any): IReduxAction => ({
  payload,
  type: SET_FOLLOWED_GROUPS,
});
export const setAllGroupsForFollowedLeaders = (payload: any): IReduxAction => ({
  payload,
  type: SET_ALL_GROUPS_FOR_FOLLOWED_LEADERS,
});

export const updateFollowList = (payload: any): IReduxAction => ({
  payload,
  type: UPDATE_FOLLOW_LIST,
});

export const removeFollowList = (payload: any): IReduxAction => ({
  payload,
  type: REMOVE_FOLLOWED_GROUP,
});

export const resetLeadersPage = () => ({
  type: RESET_LEADERS_PAGE,
});
